import { useQuery } from 'react-query';
import { z } from 'zod';

import Api from '../../api/api';

const subCategoryPageSchema = z.object({
  data: z.array(
    z
      .object({
        id: z.string().uuid(),
        title: z.string(),
        parent: z.object({ id: z.string().uuid(), title: z.string() }).passthrough(),
      })
      .passthrough(),
  ),
  total: z.number().int().nonnegative(),
  page: z.number().int().nonnegative(),
  limit: z.number().int().nonnegative(),
});
export type SubCategoryPage = z.infer<typeof subCategoryPageSchema>;

export const getSubCategoriesByPage = async (page: number, sort: string, search?: string): Promise<SubCategoryPage> => {
  const [response, bodyOrError] = await Api.get(`sub-categories`, {
    page,
    sort,
    search,
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  const json: unknown = bodyOrError;
  return subCategoryPageSchema.parse(json);
};

export const useGetSubCategoriesByPage = ({
  page,
  sort,
  search = '',
  enabled = true,
}: {
  page: number;
  sort: string;
  search?: string;
  enabled?: boolean;
}) =>
  useQuery(['getSubCategoriesByPage', page, sort, search], () => getSubCategoriesByPage(page, sort, search), {
    enabled,
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
